<script>
export default {
  name: "LeftArrow"
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="fill-current h-6 w-6 "
    viewBox="0 0 256 256"
  >
    <path
      d="M208,72H128V32a8,8,0,0,0-13.66-5.66l-96,96a8,8,0,0,0,0,11.32l96,96A8,8,0,0,0,128,224V184h80a16,16,0,0,0,16-16V88A16,16,0,0,0,208,72Zm0,96H120a8,8,0,0,0-8,8v28.69L35.31,128,112,51.31V80a8,8,0,0,0,8,8h88Z"
    ></path>
  </svg>
</template>

<style scoped></style>
